import { MedicineInterface } from "../../components/Inventory-Stocks & Orders/StockMedicineView";
import { ENDPOINTS, getFullUrl } from "./config";

export class MedicineService {
  static getToken(): string | null {
    return localStorage.getItem("token");
  }

  static getRole(): string | null {
    return localStorage.getItem("auth_user");
  }

  static async getMedicineListing({
    page = 1,
    pageSize = 10,
    clinicId,
    medicalCampId,
  }: {
    page?: number;
    pageSize?: number;
    clinicId: string;
    medicalCampId: string;
  }): Promise<{
    success: boolean;
    message?: string;
    data?: {
      totalItemsCount: number;
      totalPages: number;
      currentPage: number;
      medicines: Medicine[];
    };
  }> {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        pageSize: pageSize.toString(),
        clinicId,
        medicalCampId,
      });
  
      const url = `${getFullUrl(ENDPOINTS.MEDICINE.GETMEDICINELISTING)}?${params.toString()}`;
  
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const json = await response.json();
  
      return {
        success: json.success,
        message: json.message,
        data: {
          totalItemsCount: json.data.totalItemsCount,
          totalPages: json.data.totalPages,
          currentPage: json.data.currentPage,
          medicines: json.data.medicines,
        },
      };
    } catch (error) {
      return {
        success: false,
        message:
          error instanceof Error
            ? error.message
            : "Failed to fetch medicine listing",
      };
    }
  }
  

  static async addNewMedicine(medicineData: MedicineInterface) {
    try {
      const url = new URL(getFullUrl(ENDPOINTS.MEDICINE.CREATENEWMEDICINE));

      const response = await fetch(url, {
        method: "POST", 
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
        body: JSON.stringify(medicineData),
      });

      return await response.json();
    } catch (error) {
      return {
        success: false,
        message:
          error instanceof Error
            ? error.message
            : "Failed to add new medicine",
      };
    }
  }

  static async updateMedicine(medicineId: string, updatedData: MedicineInterface) {
    try {
      const url = new URL(
        getFullUrl(ENDPOINTS.MEDICINE.UPDATEMEDICINE).replace(
          ":id", 
          medicineId
        )
      );

      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
        body: JSON.stringify(updatedData),
      });

      return await response.json();
    } catch (error) {
      return {
        success: false,
        message:
          error instanceof Error
            ? error.message
            : "Failed to update medicine",
      };
    }
  }

  static async deleteMedicine(medicineId: string) {
    try {
      const url = new URL(
        getFullUrl(ENDPOINTS.MEDICINE.DELETEMEDICINE).replace(
          ":id", 
          medicineId
        )
      );

      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
      });

      return await response.json();
    } catch (error) {
      return {
        success: false,
        message:
          error instanceof Error
            ? error.message
            : "Failed to delete medicine",
      };
    }
  }
}
